export type ContentPart = string | { blockId: string };

const REF = /\[\[block:([a-z0-9_]+)\]\]/gi;

export function splitByBlockRefs(content: string): ContentPart[] {
  const parts: ContentPart[] = [];
  let last = 0;
  for (const match of content.matchAll(REF)) {
    const index = match.index ?? 0;
    if (index > last) parts.push(content.slice(last, index));
    parts.push({ blockId: match[1] });
    last = index + match[0].length;
  }
  if (last < content.length) parts.push(content.slice(last));
  return parts;
}

export function isInternalHref(href?: string) {
  if (
    !href ||
    !href.startsWith("/") ||
    href.startsWith("//") ||
    href.includes("\\")
  )
    return false;
  try {
    return (
      new URL(href, window.location.origin).origin === window.location.origin
    );
  } catch {
    return false;
  }
}
